import React, {Component, useEffect} from 'react';
import { connect } from 'react-redux';


const PlayIcon = ({link}) => {


  useEffect(() => {
    // $('.js-open-testimonial-iframe-popup').magnificPopup({type:'iframe'});
  }, []);

  const showPopup = (e) => {
    e.preventDefault();

    // ('.js-open-testimonial-iframe-popup').magnificPopup({
    //   type: 'iframe',
    //   iframe: {
    //     patterns: {
    //       anyUrl: {
    //         id(url) {
    //
    //           return url;
    //
    //         },
    //         src: '%id%',
    //       },
    //     },
    //   },
    // });
  }

  return <a href={link} className="js-open-testimonial-iframe-popup" onClick={(e) => showPopup(e)}>
    <svg id="Group_462" data-name="Group 462" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <circle id="Ellipse_34" data-name="Ellipse 34" cx="10" cy="10" r="10" fill="#5ac3ff"/>
      <path id="select-arrows" d="M3.284,0,0,4.6H6.567L3.284,0Zm0,10.294h0L0,7.224Z" transform="translate(13.326 6.564) rotate(90)" fill="#fff"/>
    </svg>
  </a>
}

export default PlayIcon;
